import { phoneNumber } from 'constants/index';

const typeTemplate = '${label} không đúng định dạng ${type}';

const validateMessages = {
  default: 'Validation error on field ${label}',
  required: '${label} là bắt buộc',
  enum: '${label} must be one of [${enum}]',
  whitespace: '${label} là bắt buộc',
  date: {
    format: '${label} is invalid for format date',
    parse: '${label} could not be parsed as date',
    invalid: '${label} is invalid date',
  },
  types: {
    string: typeTemplate,
    method: typeTemplate,
    array: typeTemplate,
    object: typeTemplate,
    number: typeTemplate,
    date: typeTemplate,
    boolean: typeTemplate,
    integer: typeTemplate,
    float: typeTemplate,
    regexp: typeTemplate,
    email: typeTemplate,
    url: typeTemplate,
    hex: typeTemplate,
  },
  string: {
    len: '${label} must be exactly ${len} characters',
    min: '${label} must be at least ${min} characters',
    max: '${label} cannot be longer than ${max} characters',
    range: '${label} must be between ${min} and ${max} characters',
  },
  number: {
    len: '${label} must equal ${len}',
    min: '${label} cannot be less than ${min}',
    max: '${label} cannot be greater than ${max}',
    range: '${label} must be between ${min} and ${max}',
  },
  array: {
    len: '${label} must be exactly ${len} in length',
    min: '${label} cannot be less than ${min} in length',
    max: '${label} cannot be greater than ${max} in length',
    range: '${label} must be between ${min} and ${max} in length',
  },
  pattern: {
    mismatch: '${label} không đúng định dạng',
  },
};

const mstValidator = new Array<object>({
  required: true,
});

const merchantNameValidator = new Array<object>({
  required: true,
});

const businessTypeValidator = new Array<object>({
  required: true,
});

const mmcValidator = new Array<object>({
  required: true,
});

const addressValidator = new Array<object>({
  required: true,
});

const provinceValidator = new Array<object>({
  required: true,
  message: 'Tỉnh/Thành phố là bắt buộc',
});

const districtValidator = new Array<object>({
  required: true,
  message: 'Quận/Huyện là bắt buộc',
});

const wardValidator = new Array<object>({
  required: true,
  message: 'Phường/Xã phố là bắt buộc',
});

const contactNameValidator = new Array<object>(
  {
    required: true,
  },
  {
    pattern: /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀẾỂưạảấầẩẫậắằẳẵặẹẻẽềếểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ\s]+$/,
    message: 'Không bao gồm số và ký tự đặc biệt',
  }
);

const contactEmailValidator = new Array<object>(
  {
    required: true,
  },
  {
    type: 'email',
  }
);

const contactPhoneValidator = new Array<object>(
  {
    required: true,
  },
  {
    pattern: /^(\+84|0)\d{9}$/,
    message: 'Số điện thoại không đúng',
  }
);

const shopNameValidator = new Array<object>(
  {
    required: true,
  },
  {
    max: 200,
    message: 'Vượt quá 200 ký tự',
  },
  {
    pattern: /^[^!@#$%^&*()_\-+=<>?:"|']+$/g,
    message: 'Vui lòng không nhập các ký tự đặc biệt !@#$%^&*()_-+=<>?:"|',
  }
);

const shopAddressValidator = new Array<object>(
  {
    required: true,
  },
  {
    max: 200,
    message: 'Vượt quá 200 ký tự',
  }
);

const contactPhoneVietNam = new Array<object>(
  {
    required: true,
  },
  {
    validator: (_: any, value: string) => {
      if (value.startsWith('+84')) {
        value = value.replace('+84', '0');
      }
      if (value.length !== 10) {
        return Promise.reject('Số điện thoại không hợp lệ. Vui lòng nhập lại');
      }
      for (const prefix of phoneNumber.VIETNAM_PHONE_NUMBER_PREFIX) {
        if (value.startsWith(prefix)) {
          return Promise.resolve();
        }
      }
      return Promise.reject('Số điện thoại không hợp lệ. Vui lòng nhập lại');
    },
  }
);

const merchantBrand = new Array<object>(
  {
    required: true,
  },
  {
    max: 200,
    message: 'Vượt quá 200 ký tự',
  },
  {
    pattern: /^[^!@#$%^&*()_\-+=<>?:"|']+$/g,
    message: 'Vui lòng không nhập các ký tự đặc biệt !@#$%^&*()_-+=<>?:"|',
  }
);

const contractInfo = new Array<object>(
  {
    required: true,
    transform: (value: string) => {
      return value?.trim();
    },
  },
  {
    max: 255,
    message: 'Vượt quá 255 ký tự',
  },
  {
    pattern: /^[^!@#$%^&*()_+=<>?:"|']+$/g,
    message: "Số hợp đồng chỉ bao gồm chữ, số và kí tự đặc biệt '/' và '-'",
  }
);

const contractInfoPartner = new Array<object>(
  {
    required: false,
  },
  {
    max: 255,
    message: 'Vượt quá 255 ký tự',
  },
  {
    pattern: /^[^!@#$%^&*()_+=<>?:"|']+$/g,
    message: "Số hợp đồng chỉ bao gồm chữ, số và kí tự đặc biệt '/' và '-'",
  }
);

export default {
  validateMessages,
  mstValidator,
  merchantNameValidator,
  businessTypeValidator,
  mmcValidator,
  addressValidator,
  provinceValidator,
  districtValidator,
  wardValidator,
  contactNameValidator,
  contactEmailValidator,
  contactPhoneValidator,
  shopNameValidator,
  shopAddressValidator,
  contactPhoneVietNam,
  merchantBrand,
  contractInfo,
  contractInfoPartner,
};
